import { Button, Col, Row } from "antd";

function RejectedOffer({ loading, t }) {
  return (
    <>
      <h2 className="text-center fsize-5 text--blue-2 fw-bold">
        {t("notificationModal.rejectOffer")}
      </h2>
      <Row gutter={24}>
        <Col span={24}>
          <p className="mb-3 text-center fsize-9">
            {t("notificationModal.rejectMsg")}
          </p>
        </Col>

        <Button
          type="submit"
          htmlType="submit"
          loading={loading}
          className={`text-center d-block fsize-5 py-1 px-4 px-lg-5 mx-auto h-auto fw-500 orders__order__offer-btn orders__order__offer-btn--reject`}
        >
          {t(`notificationModal.reject`)}
        </Button>
      </Row>
    </>
  );
}

export default RejectedOffer;
